export default __webpack_public_path__ + "static/media/logo-footer@200.d55d1d4f.png";